/**
* @file 国际化版详情页模板
* @author Ice(chenzhouji@baidu.com)
*/
import _ from 'lodash';
import React, {FunctionComponent, Fragment} from 'react';
import Helmet from 'react-helmet';
import Post from '@/templates/acg-portal-en/components/Post';
import {graphql} from 'gatsby';
import useSeo from '@/hooks/useSeo';
import flattenTree from '@/hooks/useSearchInput/flattenTree';

const PostTemplate: FunctionComponent<PostTemplateProps> = ({
    data,
    pageContext,
    name,
    pdfLink,
    description,
    repoName,
    location,
    seo,
    menuItems,
    slugName
}) => {
    const post = data.markdownRemark || {};
    const {next, prev} = pageContext;
    const product = {name, description, repoName};
    
    const title = seo.title || `${description}${name} - ${_.get(post, 'fields.title', '')} | Baidu AI Cloud Docs`;
    const desc = seo.description || '';
    const keywords = seo.keywords || '';
    const flatMenuItems = flattenTree(menuItems);

    const slug = _.get(post, 'fields.slug', '').replace(/(^\/)|(\/$)/g, '');
    const currentMunu = flatMenuItems.find(item => slug === (slugName === 'uuid' ? item.id : item.filePath.replace('.md', '')));
    const filePaths = currentMunu ? currentMunu.filePath.split('/') : [];

    const breadcrumb = [{
        name: product.repoName,
    }].concat(filePaths.map(path => ({
        name: path.replace('.md', '')
    })));

    useSeo({title, keywords, description: desc})

    return (
        <Fragment>
            <Helmet>
                <link rel="shortcut icon" href="https://bce.bdstatic.com/img/favicon.ico" type="image/x-icon"></link>
            </Helmet>
            <Post
                post={post}
                next={next}
                prev={prev}
                location={location}
                downloadHref={pdfLink}
                breadcrumb={breadcrumb}
                template="acg-portal-en"
                lang="en"
            />
        </Fragment>
    );
};

export default PostTemplate;

export const query = graphql`
    query PostAcgPortalEnQuery($slug: String!) {
        markdownRemark(fields: {slug: {eq: $slug}}) {
            html
            fields {
                slug
                title
                date
            }
            headings {
                value
                depth
            }
        }
    }
`;
